import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {FolderEntity} from './folder.entity';

@EntityTable('layer', '7bb859d5-4933-4b61-84db-0595cda03114')
export class LayerEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.HTML)
    public html: any;

    @Column(FieldTypeKind.ANY)
    public context: any;

    @Column(FieldTypeKind.ANY)
    public options: any;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @JoinColumn(FieldTypeKind.GUID, FolderEntity, true, false, FieldRelationKind.BELONGS_TO, 'folder', 'aliasId', 'folderId')
    public folderId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;
}
